<template>
	<div id="app">

        <div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">BetRadar NFL Scores</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label>Year</label>
							<select @change="selectYear" class="form-control">
								<option value="">-- Select --</option>
								<option value="2017">2013</option>
                                <option value="2017">2014</option>
                                <option value="2017">2015</option>
                                <option value="2017">2016</option>
                                <option value="2017">2017</option>
                                <option value="2018" selected>2018</option>
                                <option value="2019">2019</option>
							</select>
						</div>
					</div>
                    <div class="col">
						<div class="form-group">
							<label>Division</label>
							<select @change="selectDivision" class="form-control">
								<option value="">-- Select --</option>
                                <option value="FBS" selected>FBS</option>
                                <option value="FCS" selected>FCS</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Season</label>
							<select @change="selectSeason" class="form-control">
								<option value="">-- Select --</option>
                                <option value="REG" selected>REG - Regular season</option>
							</select>
						</div>
					</div>
                    <div class="col">
						<div class="form-group">
							<label>Week</label>
							<select @change="selectWeek" class="form-control">
								<option value="">-- Select --</option>
								<option v-for="n in 16" :value="n">{{n}}</option>
							</select>
						</div>
					</div>
				</div>
				
				<div>
					<p>These are the BetRadar endpoints used to build this page.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Standings</td>
							<td>
                                <a :href="getStandingsEndpoint(true)" target="_blank">{{ getStandingsEndpoint(true) }}</a>
                            </td>
						</tr>

                        <tr>
							<td>Rankings</td>
							<td>
                                <a :href="getRankingsEndpoint(true)" target="_blank">{{ getRankingsEndpoint(true) }}</a>
                            </td>
						</tr>

                        <tr>
							<td>Team Hierarchy</td>
							<td>
                                <a :href="getTeamHierarchyEndpoint(true)" target="_blank">{{ getTeamHierarchyEndpoint(true) }}</a>
                            </td>
						</tr>

                        <tr>
							<td>Weekly Division Leaders </td>
							<td>
                                <a :href="getWeeklyDivisionLeadersEndpoint(true)" target="_blank">{{ getWeeklyDivisionLeadersEndpoint(true) }}</a>
                            </td>
						</tr>
					</table>
				</div>
				
			</div>
		</div>

        <div>
            <div id="accordion">
                <div class="card" v-if="standings">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#standings" aria-expanded="true" aria-controls="collapseOne">
							Standings
							</button>
						</h5>
					</div>

					<div id="standings" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">

                            <div v-if="standings.division">
                                <h3>Division {{standings.division.name}} - id: {{standings.division.id}}</h3>
                                
                                <div v-for="conference in standings.division.conferences">
                                    <h4>Conference {{ conference.name }}</h4>

                                    <div v-for="team in conference.teams">
                                        <h5>{{ team.market }} {{ team.name }}</h5>
                                        
                                        <table class="table">
                                            <tr>
                                                <th>name</th>
                                                <th>wins</th>
                                                <th>losses</th>
                                                <th>ties</th>
                                                <th>wpct</th>
                                                <th>for</th>
                                                <th>against</th>
                                                <th>net</th>
                                                <th>type</th>
                                                <th>value</th>
                                            </tr>
                                            <tr v-for="standings_field in standings_fields">
                                                <td>{{standings_field}}</td>
                                                <td><span v-if="team[standings_field]">{{ team[standings_field].wins }}</span></td>
                                                <td><span v-if="team[standings_field]">{{ team[standings_field].losses }}</span></td>
                                                <td><span v-if="team[standings_field]">{{ team[standings_field].ties }}</span></td>
                                                <td><span v-if="team[standings_field]">{{ team[standings_field].wpct }}</span></td>
                                                <td><span v-if="team[standings_field]">{{ team[standings_field].for }}</span></td>
                                                <td><span v-if="team[standings_field]">{{ team[standings_field].against }}</span></td>
                                                <td><span v-if="team[standings_field]">{{ team[standings_field].net }}</span></td>
                                                <td><span v-if="team[standings_field]">{{ team[standings_field].type }}</span></td>
                                                <td><span v-if="team[standings_field]">{{ team[standings_field].value }}</span></td>
                                            </tr>
                                        </table>
                                    </div>

                                </div>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="rankings != []">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#rankings" aria-expanded="true" aria-controls="collapseOne">
							Rankings
							</button>
						</h5>
					</div>

					<div id="rankings" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
                            
                            <div class="form-group">
                                <label>Poll Name</label>
                                <select @change="selectPollName" class="form-control">
                                    <option value="">-- Select --</option>
                                    <option value="AP25" selected>AP25</option>
                                    <option value="EU25">EU25</option>
                                    <option value="CFP25">CFP25</option>
                                    <option value="FCSC25">FCSC25</option>
                                    <option value="H25">H25</option>
                                    <option value="FCS25">FCS25</option>
                                </select>
                            </div>


                            <h3>{{ rankings.name }}</h3>

                            <table class="table">
                                <tr>
                                    <th>team</th>
                                    <th>rank</th>
                                    <th>points</th>
                                    <th>fp_votes</th>
                                </tr>
                                <tr v-for="team in rankings.rankings">
                                    <td>{{ team.market }} {{ team.name }}</td>
                                    <td>{{ team.rank }}</td>
                                    <td>{{ team.points }}</td>
                                    <td>{{ team.fp_votes }}</td>
                                </tr>
                            </table>
						</div>
					</div>
				</div>

                <div class="card" v-if="team_hierarchy">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#team-hierarchy" aria-expanded="true" aria-controls="collapseOne">
							Team Hierarchy
							</button>
						</h5>
					</div>

					<div id="team-hierarchy" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
						
                            <div v-for="conference in team_hierarchy.conferences">
                                <h3>Conference {{ conference.name }}</h3>

                                <div v-for="conference in team_hierarchy.conferences">

                                    <h4>Conference {{conference.name}} - id: {{conference.id}}</h4>
                                    
                                    <table class="table">
                                        <tr>
                                            <th>team</th>
                                            <th>venue</th>
                                        </tr>
                                        <tr v-for="team in conference.teams">
                                            <td>{{ team.market }} {{ team.name }}</td>
                                            <td>
                                                <div v-if="team.venue">
                                                    id: {{ team.venue.id }}<br>
                                                    country: {{ team.venue.country }}<br>
                                                    name: {{ team.venue.name }}<br>
                                                    city: {{ team.venue.city }}<br>
                                                    state: {{ team.venue.state }}<br>
                                                    capacity: {{ team.venue.capacity }}<br>
                                                    surface: {{ team.venue.surface }}<br>
                                                    type: {{ team.venue.type }}<br>
                                                    zip: {{ team.venue.zip }}<br>
                                                    address: {{ team.venue.address }}<br>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="weekly_division_leaders">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#weekly-league-leaders" aria-expanded="true" aria-controls="collapseOne">
							Weekly Division Leaders 
							</button>
						</h5>
					</div>

					<div id="weekly-league-leaders" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
                            
                            <div v-if="weekly_division_leaders.division">
                                <div v-for="statistics_type in statistics_types">

                                    <h3>{{ statistics_type.name }}</h3>

                                    <table class="table">
                                        <tr>
                                            <th>name</th>
                                            <th>id</th>
                                            <th>jersey</th>
                                            <th>position</th>
                                            <th>team</th>
                                            <template v-for="field in statistics_type.fields">
                                                <th>{{field}}</th>
                                            </template>
                                        </tr>
                                        <tr v-for="record in weekly_division_leaders.division[statistics_type.name]">
                                            <td>{{ record.name }}</td>
                                            <td>{{ record.id }}</td>
                                            <td>{{ record.jersey }}</td>
                                            <td>{{ record.position }}</td>
                                            <td>
                                                {{ record.team.market }} {{ record.team.name }}
                                            </td>
                                            <template v-for="field in statistics_type.fields">
                                                <td>{{record[field]}}</td>
                                            </template>
                                        </tr>
                                    </table>
                                </div>
                            </div>
						</div>
					</div>
				</div>

            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'app',
    components: {

	},
    created: function() {

        this.loadStandings();
        this.loadRankings();
        this.loadTeamHierarchy();
        this.loadWeeklyDivisionLeaders();
    
    },
    data: function() {
        return {            
            apiKey: 'p7y658w3n9ezma28k5ywv2p7',
            year: 2018,
            season: "REG",
            week: 1,
            division: 'FCS',
            poll_name: 'AP25',
            standings: [],
            rankings: [],
            standings_fields: [
                'overall',
                'in_conference',
                'non_conference',
                'in_division',
                'home',
                'away',
                'overtime',
                'grass',
                'turf',
                'scored_first',
                'decided_by_7_points',
                'leading_at_half',
                'last_5',
                'points',
                'touchdowns',
                'streak',
            ],
            team_hierarchy: [],
            weekly_division_leaders: [],
            statistics_types: [
                {
                    name: "passing",
                    fields: [
                        "att",
                        "cmp",
                        "yds",
                        "lg",
                        "sk",
                        "sk_yds",
                        "td",
                        "int",
                        "int_td",
                        "fd",
                        "sfty",
                        "rz_att",
                        "rating",
                        "avg",
                        "cmp_pct",
                        "cmp_avg",
                        "td_pct",
                        "int_pct",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "rushing",
                    fields: [
                        "att",
                        "yds",
                        "avg",
                        "lg",
                        "td",
                        "fd",
                        "fd_pct",
                        "sfty",
                        "rz_att",
                        "fum",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
                {
                    name: "receiving",
                    fields: [
                        "tar",
                        "rec",
                        "yds",
                        "yac",
                        "fd",
                        "avg",
                        "td",
                        "lg",
                        "rz_tar",
                        "fum",
                        "yds_10_pls",
                        "yds_20_pls",
                        "yds_30_pls",
                        "yds_40_pls",
                        "yds_50_pls",
                    ]
                },
            ]
        }
    }, 
    methods: {
        getStandingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/ncaafb-rt1/teams/${this.division}/${this.year}/${this.season}/standings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getRankingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/ncaafb-rt1/polls/${this.poll_name}/${this.year}/${this.week}/rankings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getTeamHierarchyEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/ncaafb-rt1/teams/${this.division}/hierarchy.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getWeeklyDivisionLeadersEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/ncaafb-rt1/${this.year}/${this.season}/${this.week}/${this.division}/leaders.json?api_key=${this.apiKey}`;


            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        

        loadStandings: function() {

            // get full list of tournaments
            axios.get(this.getStandingsEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('standings', response.data);

                this.standings = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadRankings: function() {

            // get full list of tournaments
            axios.get(this.getRankingsEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('rankings', response.data);

                this.rankings = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadTeamHierarchy: function() {

            // get full list of tournaments
            axios.get(this.getTeamHierarchyEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('team_hierarchy', response.data);

                this.team_hierarchy = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadWeeklyDivisionLeaders: function() {

            // get full list of tournaments
            axios.get(this.getWeeklyDivisionLeadersEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('weekly_division_leaders', response.data);

                this.weekly_division_leaders = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        selectYear: function(event) {
			
			this.year = event.target.value;
            this.loadStandings();
            this.loadRankings();
            this.loadTeamHierarchy();
            this.loadWeeklyDivisionLeaders();
        },

        selectDivision: function(event) {

            this.division = event.target.value;
            this.loadStandings();
            this.loadRankings();
            this.loadTeamHierarchy();
            this.loadWeeklyDivisionLeaders();
        },

        selectSeason: function(event) {
			
			this.season = event.target.value;
            this.loadStandings();
            this.loadRankings();
            this.loadTeamHierarchy();
            this.loadWeeklyDivisionLeaders();
        },

        selectWeek: function(event) {

            this.week = event.target.value;
            this.loadStandings();
            this.loadRankings();
            this.loadTeamHierarchy();
            this.loadWeeklyDivisionLeaders();
        },

        selectPollName: function(event) {

            this.poll_name = event.target.value;
            this.loadStandings();
            this.loadRankings();
            this.loadTeamHierarchy();
            this.loadWeeklyDivisionLeaders();
        }
    },
}
</script>